module.exports = __webpack_public_path__ + "img/codorniu_09.b244e263.png";